import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Toast } from 'models/toasts';

type PropsType = {
  toast: Toast;
};

const DefaultErrorToast: React.FunctionComponent<PropsType> = ({ toast }) => {
  const { t } = useTranslation('toast');

  return (
    <React.Fragment>
      <ErrorToastHeader>
        <strong className="mr-auto">
          {toast.content.title ? toast.content.title : t('vieurekaApp')}
        </strong>
      </ErrorToastHeader>
      <div className="toast-body">{toast.content.message}</div>
    </React.Fragment>
  );
};

const ErrorToastHeader = styled.div`
  display: flex;
  align-items: center;
  height: 37px;
  padding: 0.25rem 0.75rem;
  white-space: pre-line;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`;

export default DefaultErrorToast;
